import { Component, ChangeDetectionStrategy, inject, input, computed, signal } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { of, switchMap, throwError } from 'rxjs';
import { ItemGridComponent } from '../item-grid/item-grid.component';
import { BrandCardComponent } from '../brand-card/brand-card.component';
import { AuthService, CacheService } from '../../auth.service';
import { PaintDirective } from '../../paint.directive';
import { toObservable } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { backend } from '../../../environments/environment';
import { humanize, IBrandCard, IPlan } from '../../types';
import { LocationService } from '../../location.service';
import { HumanizePipe } from "../../humanize.pipe";

interface ICategoryGroup {
  _id: string;
  name: string;
  slug: string;
  position: number;
  brands: IBrandCard[];
}

@Component({
  selector: 'catalogue-premium',
  templateUrl: './catalogue-premium.component.html',
  styleUrls: ['./catalogue-premium.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTabsModule, ItemGridComponent, BrandCardComponent, PaintDirective]
})
export default class CataloguePremiumComponent {
  activated = inject(ActivatedRoute);
  auth = inject(AuthService);
  http = inject(HttpClient);
  router = inject(LocationService);
  cache = inject(CacheService);

  plan = input.required<string, string>({ transform: (p) => p ?? 'premium'});

  first_plan = computed(() => this.plan().split(',').at(0)!);

  first_plan_string = computed(() => humanize(this.first_plan()));

  animating = signal<boolean>(false);
  category_groups = signal<ICategoryGroup[]>([]);
  index = signal<number>(0);


  title = signal<string>('');
  text = signal<string>('');
  subtext = signal<string>('');

  constructor() {
    const { title, text, subtext, tab } = this.activated.snapshot.queryParams;

    this.title.set(title);
    this.text.set(text);
    this.subtext.set(subtext);

    toObservable(this.plan).pipe(
      switchMap(plans => {
        if(!plans){
          return throwError(() => new Error('No Plan Provided'))
        }
        return this.http.get<{ result: ICategoryGroup[], plans: IPlan[] }>(backend + 'catalogue', { params: { plans }});
      }),
      switchMap(response => response?.result.length ? of(response) : throwError(() => new Error('No categories for plans')))
    ).subscribe({
      next: ({ result, plans }) => {
        this.category_groups.set(result);
        this.cache.registerPlans(plans);

        if(tab){
          const category = this.category_groups().findIndex(c => c.slug == tab);
          if(category != -1){
            this.index.set(category);
          }
        }
      },
      error: error => {
        console.error('Catalogue Error', error);
        this.router.navigate(['/premium'], { replaceUrl: true });
      }
    });
  }

  swipe(direction: string){
    if(direction != 'swipeleft' && direction != 'swiperight') return;
    const index = this.index();

    if(direction == 'swipeleft' && index < this.category_groups().length)
      this.index.update(index => index+1);

    if(direction == 'swiperight' && index > 0)
      this.index.update(index => index-1);
  }
}
